import React from 'react';
import s from './LoadingDots.scss';

export const LoadingDots: React.FC = () => (
  <div className={s.loadingDots}>
    <div className={s.dot} />
    <div className={s.dot} />
    <div className={s.dot} />
  </div>
);
